import React from "react";
import { Link } from "react-router-dom";
import propellerIcon from '../images/PROPELLER_ICON.svg';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container text-center">
        Provided by{" "}
        <Link className="logo__link" to="http://saxeit.com/" target="_blank">
          <img src={propellerIcon} alt="Saxe IT" className="logo" />
          Saxe IT
        </Link>{" "}
        {currentYear} all rights reserved.    <a className="privacy-polocy__link" href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
     
      </div>
    </footer>
  );
};

export default Footer;